var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.5L6.58073 4.9592L6.58225 4.96047C7.09089 5.33346 7.34535 5.52007 7.62407 5.59216C7.87042 5.65588 8.12938 5.65588 8.37573 5.59216C8.6547 5.52001 8.9099 5.33285 9.41943 4.9592C9.41943 4.9592 12.3576 2.70446 14 1.5M1.25 8.85015V3.15015C1.25 2.31007 1.25 1.88972 1.41349 1.56885C1.5573 1.2866 1.7866 1.0573 2.06885 0.91349C2.38972 0.75 2.81007 0.75 3.65015 0.75H12.3501C13.1902 0.75 13.6097 0.75 13.9305 0.91349C14.2128 1.0573 14.4429 1.2866 14.5867 1.56885C14.75 1.8894 14.75 2.30925 14.75 3.14768V8.85269C14.75 9.69112 14.75 10.1104 14.5867 10.4309C14.4429 10.7132 14.2128 10.9429 13.9305 11.0867C13.61 11.25 13.1908 11.25 12.3523 11.25H3.64768C2.80925 11.25 2.3894 11.25 2.06885 11.0867C1.7866 10.9429 1.5573 10.7132 1.41349 10.4309C1.25 10.11 1.25 9.69023 1.25 8.85015Z",
    stroke: "#989DA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOutline);
export default __webpack_public_path__ + "static/media/email-outline.6ce34055240d832cf160c54505578d44.svg";
export { ForwardRef as ReactComponent };